<div class="main-container">
    <app-list-header
        [title]="title"
        icon="flag"
        [searchPlaceholder]="'priorities.search' | translate"
        [searchTerm]="searchTerm | async"
        (searchTermChange)="searchTerm.next($event); searchPriority()"
        (clearSearch)="clearFilter()"
        (addNewItem)="createPriority()"
    ></app-list-header>

    <div class="table-container">
        <table class="list-table">
            <tbody>
                <tr
                    *ngFor="let priority of filteredPriority | async"
                    (click)="select(priority)"
                    [class.selected]="priority === selectedPriority"
                >
                    <td class="color-cell">
                        <span class="color-dot" [style.background-color]="priority.color"></span>
                    </td>
                    <td class="name-cell">{{ priority.value }}</td>
                    <td class="importance-cell">
                        <span class="importance-badge">{{ priority.importance }}</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
